import React from 'react';
import { Check } from 'lucide-react';
const benefits = ['Diseño personalizado para tu negocio', '100% optimizada para móvil', 'Botones de llamada y WhatsApp directo', 'Formulario de contacto/reservas', 'Mapa de Google integrado', 'SEO básico configurado', 'SSL (seguridad) incluida', 'Entrega en 7 días o menos', '1 revisión incluida'];
export function Pricing() {
  return <section id="precios" className="py-24 px-6 relative bg-background overflow-hidden" data-id="element-147">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-primary/10 rounded-full blur-[120px] pointer-events-none" data-id="element-148"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-149">
        <div className="text-center mb-16" data-id="element-150">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-6" data-id="element-151">
            La Inversión Más Inteligente Que Puedes Hacer Hoy
          </h2>
          <p className="text-xl text-text-secondary max-w-2xl mx-auto" data-id="element-152">
            Si tu página web te trae un solo cliente nuevo al mes — solo uno —
            ¿cuánto vale eso para tu negocio?
          </p>
        </div>

        <div className="max-w-lg mx-auto" data-id="element-153">
          <div className="glass-panel rounded-3xl p-1 relative overflow-hidden group" data-id="element-154">
            {/* Animated border gradient */}
            <div className="absolute inset-0 bg-gradient-to-br from-primary via-accent-start to-primary opacity-30 group-hover:opacity-50 transition-opacity duration-500" data-id="element-155"></div>

            <div className="relative bg-[#0F111A] rounded-[22px] p-8 md:p-10 h-full flex flex-col" data-id="element-156">
              <div className="text-center mb-8" data-id="element-157">
                <span className="inline-block px-4 py-1.5 rounded-full bg-primary/10 text-primary text-sm font-bold tracking-wider uppercase mb-4 border border-primary/20" data-id="element-158">
                  Krove Starter
                </span>
                <div className="flex items-baseline justify-center gap-2" data-id="element-159">
                  <span className="text-6xl font-bold text-white" data-id="element-160">$150</span>
                  <span className="text-xl text-text-secondary" data-id="element-161">USD</span>
                </div>
                <p className="text-text-secondary mt-2 text-sm" data-id="element-162">
                  Pago único. Sin contratos ocultos.
                </p>
              </div>

              <div className="space-y-4 mb-10 flex-1" data-id="element-163">
                {benefits.map((benefit, index) => <div key={index} className="flex items-start gap-3" data-id="element-164">
                    <div className="mt-0.5 shrink-0 w-5 h-5 rounded-full bg-accent-start/20 flex items-center justify-center" data-id="element-165">
                      <Check className="w-3 h-3 text-accent-start" data-id="element-166" />
                    </div>
                    <span className="text-gray-300 text-sm" data-id="element-167">{benefit}</span>
                  </div>)}
              </div>

              <div className="bg-white/5 border border-white/10 rounded-xl p-4 mb-8 text-center" data-id="element-168">
                <p className="text-sm text-text-secondary" data-id="element-169">
                  <span className="text-accent-start font-medium" data-id="element-170">
                    + Mantenimiento mensual opcional:
                  </span>{' '}
                  Solo $20/mes (Incluye hosting, dominio y actualizaciones)
                </p>
              </div>

              <a href="https://wa.me/573135250384?text=Hola%20Krove%20Latam%2C%20estoy%20interesad%40%20en%20tus%20servicios." target="_blank" rel="noopener noreferrer" className="w-full py-4 rounded-xl bg-gradient-accent text-background font-bold text-lg hover:opacity-90 transition-opacity flex items-center justify-center shadow-[0_0_20px_rgba(255,153,0,0.3)]" data-id="element-171">
                QUIERO MI LANDING PAGE
              </a>
            </div>
          </div>
        </div>

        <div className="mt-16 text-center text-text-secondary text-sm max-w-2xl mx-auto" data-id="element-172">
          <p data-id="element-173">
            Para un spa de uñas: entre $40 y $120 por visita. Para una barbería:
            entre $25 y $60 por servicio. Para un fisioterapeuta: entre $60 y
            $150 por sesión.{' '}
            <strong className="text-white" data-id="element-174">
              Tu Landing Page se paga sola en el primer mes.
            </strong>{' '}
            Y trabaja para ti los 12 meses del año.
          </p>
        </div>
      </div>
    </section>;
}